export default "__VITE_PUBLIC_ASSET__ec409a64__"